import { observable } from "mobx";
import { Type } from "class-transformer";
import type { EntityValidationRules } from "../services/validationService";
import type { IRefundCandidate } from "./chargeRefund";
import TransferPaymentType from "./transferPaymentType";
import TransferRefundCounterpartyBankRequest from "./transferRefundCounterpartyBankRequest";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class CustomerRefundCandidateRequest {
  /**
   * Official refund record ID.
   */
  @observable
  officialRecordId!: string;

  /**
   * Refund is without refund fee.
   */
  @observable
  isWithoutRefundFee!: boolean;

  @observable
  transferType?: TransferPaymentType;

  @observable
  @Type(() => TransferRefundCounterpartyBankRequest)
  counterpartyBank?: TransferRefundCounterpartyBankRequest;

  /**
   * Refund counterparty name.
PRZ - 1 - 70 T
PRE - 1 - 35 T
   */
  @observable
  counterpartyName?: string;

  /**
   * Refund counterparty street address.
PRZ 0 - 70 T
PRE 0 - 35 T
   */
  @observable
  counterpartyStreetAddress?: string;

  /**
   * Refund counterparty city address.
PRZ 0 - 70 T
PRE 0 - 35 T
   */
  @observable
  counterpartyCityAddress?: string;

  /**
   * Refund counterparty country ID.
   */
  @observable
  counterpartyCountryId?: string;

  /**
   * Additional AV message.
PRZ - T
   */
  @observable
  additionalAvMessage?: string;
}

export default class CustomerRefundCandidate extends CustomerRefundCandidateRequest implements IRefundCandidate {
  counterpartyBank: TransferRefundCounterpartyBankRequest = new TransferRefundCounterpartyBankRequest();
}

export const CustomerRefundCandidateValidationRules: EntityValidationRules<CustomerRefundCandidate> = {
  officialRecordId: {
    required: true,
    isLength: {
      min: 3,
      max: 50,
    },
  },
};
